'use client';
import { Box } from '@mui/material';
/**
 * Created by nicolas.looschen@pikobytes.de on 10.04.2025.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { useParams } from 'next/navigation';
import React from 'react';
import { PageSubtitle } from '../../components/ContentComponents/PageSubtitle';
import PageTitle from '../../components/ContentComponents/PageTitle';
import ContentPageHeader from '../../components/ContentPageHeader/ContentPageHeader';
import ContentSection from '../../components/ContentSection/ContentSection';
import Link from '../../components/Links/Link';
import routes from '../../configuration/routes';
import ContentPageContentLayout from '../../layouts/ContentPageContentLayout';
import { useClientSideTranslation } from '../../util/i18n/useClientSideTranslation';

export const NotFoundPage = () => {
    const params = useParams<{ lng: string }>();
    const lng = params?.lng ?? 'en';
    const { t } = useClientSideTranslation(lng, ['common']);

    return (
        <ContentSection>
            <ContentPageHeader />
            <ContentPageContentLayout>
                <PageTitle title={t('errors.notFound.title')} />
                <PageSubtitle subtitle={t('errors.notFound.description')} />
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Link href={routes.home} variant="contained">
                        {t('errors.notFound.back')}
                    </Link>
                </Box>
            </ContentPageContentLayout>
        </ContentSection>
    );
};

export default NotFoundPage;
